module.exports = __webpack_public_path__ + "img/natural_beech_416m_list.8bb6e3bd.jpg";